import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { getLang } from 'lowcomp/plugins/member/utils';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import EditorImg from 'lowcode/components/EditorImg';
import { ModalCloseIcon, CouponModalIcon } from '../icon';
import { CopyIcon, ExpandArrowBottom } from '@/components/UI/svg/Ecocredits';
import { message } from 'antd';

interface CouponModalProps {
    open?: boolean;
    coupon?: any;
    prize?: any[];
    winnerPrize?: any;
    onCancel?: () => void;
    setShowPage?: (page: string) => void;
}

const CouponModal: React.FC<CouponModalProps> = ({ open, coupon, prize, winnerPrize = {}, onCancel, setShowPage }) => {
    const { useRouter, isMobile } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    // const { t } = useLang('ecocredits');
    const t = getLang(textLang, locale);
    const winnerPrizeInList = prize?.find((item) => item.id === winnerPrize.awardsId) || {};

    const getShowBtn = (coupon: any) => {
        const { ruleType, thirdUrl } = coupon || {};

        if (ruleType === 'COUPONS') return true;

        if (ruleType === 'THIRD_COUPONS' && thirdUrl) return true;

        return false;
    };

    const shopNow = (coupon: any) => {
        const { thirdUrl, ruleType, jumpUrl } = coupon;
        if (ruleType === 'THIRD_COUPONS') {
            if (isMobile) {
                router.push(thirdUrl);
                return;
            }
            window.open(thirdUrl, '_blank');
            return;
        }

        if (ruleType === 'COUPONS' && jumpUrl) {
            if (jumpUrl.startsWith('http')) {
                setTimeout(() => window.open(jumpUrl, '_blank'));
            } else {
                window.location.href = jumpUrl;
            }
            return;
        }

        if (isMobile) {
            router.push(`https://${locale}.ecoflow.com`);
            return;
        }
        setTimeout(() => {
            window.open(`https://${locale}.ecoflow.com`, '_blank');
        });
    };

    const copyText = (text?: string) => {
        if (!text) return;

        if (navigator?.clipboard && window?.isSecureContext) {
            window.navigator.clipboard.writeText(text);
            message.success(t('site_account_profile_save_success'));
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    // message.error()
                }
                textArea.remove();
            });
            message.success(t('site_account_profile_save_success'));
        }
    };

    return (
        <EfModal className={`${css.efmodal}`} visible={open} onCancel={onCancel} zIndex={1200}>
            <style global jsx>
                {`
                    .ant-message {
                        z-index: 999999;
                        .ant-message-notice .ant-message-notice-content {
                            border-radius: 6px;
                            overflow: hidden;
                        }
                    }
                `}
            </style>
            <div className="content">
                <p className="text-header">
                    <ModalCloseIcon onClick={onCancel} />
                </p>
                <h5 className="title">
                    <EditorImg className="title-left" pc="https://websiteoss.ecoflow.com/upload/image/1730520057203/Mask%20group%20(2).png" />
                    {t('prize_coupon_title')} <CouponModalIcon className="title-right" />
                </h5>
                {winnerPrize?.prizeType !== 'INTEGRAL' && <p className="sub-title">{t('prize_coupon_sub_title')}</p>}
                <p className="sub-title">
                    {t.rich('prize_coupon_action', {
                        code: (children?: string) => (
                            <i
                                className="btn"
                                onClick={() => {
                                    setShowPage?.(winnerPrize?.prizeType === 'INTEGRAL' ? 'history_modal' : 'coupon_modal$2');
                                    onCancel?.();
                                }}
                            >
                                {winnerPrize?.prizeType === 'INTEGRAL' ? t('points_activity_a') : children}
                            </i>
                        ),
                    })}
                </p>
                <div className="prize-box">
                    {/* 奖品图片 */}
                    {winnerPrizeInList.isDisplayIcon && <div className="prize-img" style={{ backgroundImage: `url("${winnerPrizeInList.iconUrl}")` }} />}
                    {/* 奖品名称  暂不展示*/}
                    {/* {winnerPrizeInList.isDisplayName && <p className="prize-title">{winnerPrizeInList.prizeName}</p>} */}
                    {/* 优惠券码 */}
                    {coupon?.coupon && (
                        <p className="prize-title">
                            {coupon?.coupon}
                            <CopyIcon
                                onClick={(e: any) => {
                                    e.stopPropagation();
                                    copyText(coupon?.coupon);
                                }}
                            />
                        </p>
                    )}
                </div>
                {/* 优惠券使用规则 */}
                {coupon?.noteList && (
                    <div className="coupon-note">
                        {t('rules')}:&nbsp;
                        {coupon?.noteList?.map((note: string, index: number) => (
                            <span key={index} className="confirm-rule-item">
                                {note}&nbsp;
                            </span>
                        ))}
                    </div>
                )}
                {getShowBtn(coupon) && (
                    <Button onClick={() => shopNow(coupon)} className="m-btn">
                        {t('prize_coupon_button')}
                    </Button>
                )}
                {winnerPrize?.prizeType === 'INTEGRAL' && (
                    <Button onClick={onCancel} className="m-btn">
                        {t('confirm_btn_text')}
                    </Button>
                )}
            </div>
        </EfModal>
    );
};

export default CouponModal;
